<template>
  <div class="app-main-content account-book">
    <div class="details-view">
      <div class="main-content">
        <span style="position: absolute; right: 10px; margin-top: 5px;z-index: 9999">
          <el-link :type="lbAccountType" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
        </span>
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" :before-leave="handleBeforeLeave" :lazy="true" style="width:100%;" type="card">
            <el-tab-pane :label="$t('CargoMsg.Cargo_SubsidiaryLedger')" name="flowChartMultiCurrency">
              <!-- 对应 cargoware的 FinacialFlowChartView2MultiCurrency -->
              <finacial-flow-chart-view2-multi-currency ref="flowChartMultiCurrency" :account-set="accountSet" :used-currency-collection="usedCurrencyCollection" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_StatementOfBalance')" :lazy="true" name="dbViewMultiCurrency">
              <!-- 对应 cargoware的 DealingsBalanceView2MultiCurrency -->
              <dealings-balance-view2-multi-currency ref="dbViewMultiCurrency" :account-set="accountSet" :used-currency-collection="usedCurrencyCollection" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_AccountsReconciliation')" :lazy="true" name="dcaViewMultiCurrency">
              <!-- 对应 cargoware的 DealingsCheckAccountsView2MultiCurrency -->
              <dealings-check-accounts-view2-multi-currency ref="dcaViewMultiCurrency" :account-set="accountSet" :used-currency-collection="usedCurrencyCollection" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_GeneralLedger')" :lazy="true" name="glViewMultiCurrency">
              <!-- 对应 cargoware的 GeneralLedgerView2MultiCurrency -->
              <general-ledger-view2-multi-currency ref="glViewMultiCurrency" :account-set="accountSet" :used-currency-collection="usedCurrencyCollection" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_BalancesOfAccountTitle')" :lazy="true" name="atViewMultiCurrency">
              <!-- 对应 cargoware的 AccountTitleBalanceView2MultiCurrency -->
              <account-title-balance-view2-multi-currency ref="atViewMultiCurrency" :account-set="accountSet" :used-currency-collection="usedCurrencyCollection" />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_SubsidiaryLedgerDay')" :lazy="true" name="flowChartMultiCurrencyDay">
              <!-- 对应 cargoware的 FinacialFlowChartView2MultiCurrencyDay -->
              <finacial-flow-chart-view2-multi-currency-day ref="flowChartMultiCurrencyDay" :account-set="accountSet" :used-currency-collection="usedCurrencyCollection" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- 选择账套 -->
    <account-set-popup
      ref="refAccountSetPopup"
      :mode="accountSetPopup.mode"
      :visible.sync="accountSetPopup.visible"
      :load-accounting-document-type-flag="true"
      :load-mapping-departments-flag="true"
      :load-mapping-staffs-flag="true"
      :load-accounting-documents-rule-flag="false"
      :load-used-currency-flag="true"
      :sort-fiscal-period-desc="true"
      @cancel="()=>accountSetPopup.visible=false"
      @select="accountSetSelectHandler"
    />
  </div>
</template>

<script>
import FinacialFlowChartView2MultiCurrency from '@/views/cargo/v0/FinanceManage/AccountBook/FinacialFlowChartView2MultiCurrency'
import DealingsBalanceView2MultiCurrency from '@/views/cargo/v0/FinanceManage/AccountBook/DealingsBalanceView2MultiCurrency'
import DealingsCheckAccountsView2MultiCurrency from '@/views/cargo/v0/FinanceManage/AccountBook/DealingsCheckAccountsView2MultiCurrency'
import GeneralLedgerView2MultiCurrency from '@/views/cargo/v0/FinanceManage/AccountBook/GeneralLedgerView2MultiCurrency'
import AccountTitleBalanceView2MultiCurrency from '@/views/cargo/v0/FinanceManage/AccountBook/AccountTitleBalanceView2MultiCurrency'
import FinacialFlowChartView2MultiCurrencyDay from '@/views/cargo/v0/FinanceManage/AccountBook/FinacialFlowChartView2MultiCurrencyDay'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import * as accountTitleBalanceCurrencyApi from '@/api/financeManage/accountTitleBalanceCurrency'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'

export default {
  name: 'AccountBook',
  components: { FinacialFlowChartView2MultiCurrency, DealingsBalanceView2MultiCurrency, DealingsCheckAccountsView2MultiCurrency,
    GeneralLedgerView2MultiCurrency, AccountTitleBalanceView2MultiCurrency, FinacialFlowChartView2MultiCurrencyDay, AccountSetPopup },
  data() {
    return {
      activeTabName: 'flowChartMultiCurrency',
      accountSet: null, // 当前账套
      accountSetPopup: { visible: false, mode: 'office' },
      usedCurrencyCollection: []
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    },
    accountSets() {
      return this.$refs['refAccountSetPopup'] ? this.$refs['refAccountSetPopup'].rowData : []
    }
  },
  watch: {
    async accountSet(newVal) {
      if (newVal) {
        this.usedCurrencyCollection.push(this.$t('CargoMsg.Cargo_ConsolidatedLocalCurrency'))
        const currencys = this.accountSet.usedCurrency // await accountTitleBalanceCurrencyApi.getUsedCurrency({ accountSetUuid: this.accountSet.uuid }).then(resp => resp.data)
        this.usedCurrencyCollection.push(...currencys)
      }
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.accountSet === null) {
      this.selectAccountSetHandler()
    }
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      console.log('selectAccountSetHandler')
      this.accountSetPopup.visible = true
    },
    handleBeforeLeave(activeName, oldActiveName) {
      const beforeLeaveHandler = this.$refs[oldActiveName].beforeLeaveHandler
      if (beforeLeaveHandler !== undefined) {
        beforeLeaveHandler()
      }
      return true
    },
    accountSetSelectHandler(data) {
      this.accountSet = data
    }
  }
}
</script>

<style scoped>

</style>
